import React from 'react'
import SBox from 'components/opinionless/SBox'
import SFlex from 'components/opinionless/SFlex'
import SText from 'components/opinionless/SText'

interface Props {
  showEstimate: boolean
  t: (translationKey: string, options?: any) => string
  calEITCValue: number
  federalEITCValue: number
  yctcValue: number
  fytcValue: number
  ctcValue: number
}

const formatCurrency = (value: number): string => {
  const roundedValue = Math.floor(value)
  return `$${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(roundedValue)}`
}

const EstimateResults: React.FC<Props> = ({
  showEstimate,
  t,
  calEITCValue,
  federalEITCValue,
  yctcValue,
  fytcValue,
  ctcValue,
}) => {
  if (!showEstimate) return null

  return (
    <SBox mt="24px">
      <SText fontSize="32px" fontWeight={700} mb="18px">
        {t('estimate')}:
      </SText>
      <SFlex flexDirection="column">
        <SFlex flexDirection={['column', 'row']}>
          <SFlex
            flexDirection="column"
            justifyContent="space-between"
            mr={[0, '42px']}
            width={['auto', '190px']}
          >
            <SText fontSize="24px" fontWeight={600} mb="12px" mr={['24px', 0]}>
              {t('californiaEitcLabel')}
            </SText>
            <SText fontSize={['48px', '60px']} fontWeight={700} mb="12px">
              {formatCurrency(calEITCValue)}
            </SText>
          </SFlex>
          <SFlex flexDirection="column" justifyContent="space-between">
            <SText fontSize="24px" fontWeight={600} mb="12px">
              {t('federalEitcLabel')}
            </SText>
            <SText fontSize={['48px', '60px']} fontWeight={700} mb="12px">
              {formatCurrency(federalEITCValue)}
            </SText>
          </SFlex>
        </SFlex>
        <SFlex flexDirection={['column', 'row']}>
          <SFlex
            flexDirection="column"
            sx={{ marginTop: '12px' }}
            mr={[0, '32px']}
          >
            <SText
              fontSize="24px"
              fontWeight={600}
              mb="12px"
              width={['auto', '190px']}
            >
              {t('californiaYctcLabel')}
            </SText>
            <SText fontSize={['48px', '60px']} fontWeight={700} mb="12px">
              {formatCurrency(yctcValue)}
            </SText>
          </SFlex>
          <SFlex
            flexDirection="column"
            sx={{ marginTop: '12px' }}
            width={['auto', '190px']}
          >
            <SText fontSize="24px" fontWeight={600} mb="12px">
              Federal Child Tax Credit
            </SText>
            <SText fontSize={['48px', '60px']} fontWeight={700} mb="12px">
              {formatCurrency(ctcValue)}
            </SText>
          </SFlex>
        </SFlex>
        <SFlex
          flexDirection="column"
          sx={{ marginTop: '12px' }}
          width={['auto', '190px']}
        >
          <SText fontSize="24px" fontWeight={600} mb="12px">
            {t('californiaFytcLabel')}
          </SText>
          <SText fontSize={['48px', '60px']} fontWeight={700} mb="12px">
            {formatCurrency(fytcValue)}
          </SText>
          {fytcValue !== 0 && (
            <SText
              sx={{ maxWidth: '230px', fontSize: '14px', color: '#202020' }}
            >
              {t('creditDoubles')}
            </SText>
          )}
        </SFlex>
        <SText
          sx={{
            maxWidth: '600px',
            marginTop: '24px',
            fontSize: '14px',
            color: '#202020',
          }}
        >
          {t('note')}
        </SText>
      </SFlex>
    </SBox>
  )
}

export default EstimateResults
